import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "",
    loadComponent: () => import('./documentation.component').then(m => m.DocumentationComponent),
    children: [
      {
        path: "",
        loadComponent: () => import('./getting-started/getting-started.component').then(m => m.GettingStartedComponent),
        data: {
          title: "KudosHub Docs | API, Integration & Developer Guides",
          description: "Explore KudosHub Docs to learn how to integrate, authenticate, and automate using our APIs for email validation and AI email scoring. Step-by-step tutorials and live examples included.",
          keywords: "kudoshub Documentation",
          ogTitle: "KudosHub Docs | API, Integration & Developer Guides",
          ogDesc: "Explore KudosHub Docs to learn how to integrate, authenticate, and automate using our APIs for email validation and AI email scoring. Step-by-step tutorials and live examples included.",
          ogImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          ogUrl: "https://kudoshub.com/docs",
          twitterTitle: "KudosHub Docs | API, Integration & Developer Guides",
          twitterDesc: "Explore KudosHub Docs to learn how to integrate, authenticate, and automate using our APIs for email validation and AI email scoring. Step-by-step tutorials and live examples included.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          dateModified: "2025-10-30T18:30:00+05:30"
        },
      },
      {
        path: "email-validation",
        loadComponent: () => import('./email-list-validation/email-list-validation.component').then(m => m.EmailListValidationComponent),
        data: {
          title: "KudosHub Email Validation | Clean & Verify Email Lists",
          description: "Remove invalid, disposable, and risky emails with KudosHub Email Validation. Get 99% accuracy, AI scoring, and real-time verification at the lowest cost.",
          keywords: "Email Validation Documentation, email verification, email list cleaning, validate emails",
          ogTitle: "KudosHub Email Validation | Clean & Verify Email Lists",
          ogDesc: "Remove invalid, disposable, and risky emails with KudosHub Email Validation. Get 99% accuracy, AI scoring, and real-time verification at the lowest cost.",
          ogImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          ogUrl: "https://kudoshub.com/docs/email-validation",
          twitterTitle: "KudosHub Email Validation | Clean & Verify Email Lists",
          twitterDesc: "Remove invalid, disposable, and risky emails with KudosHub Email Validation. Get 99% accuracy, AI scoring, and real-time verification at the lowest cost.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          dateModified: "2025-10-30T18:30:00+05:30"
        },
      },
      {
        path: "email-validation-api",
        loadComponent: () => import('./email-validation-api/email-validation-api.component').then(m => m.EmailValidationApiComponent),
        data: {
          title: "Email Validation API | Real-Time & Bulk Verification",
          description: "Use KudosHub's Email Validation API for real time and bulk checks. Reduce bounces, score risk with AI, and protect sender reputation with 99% accuracy.",
          keywords: "email validation API, REST API, email verification API, API documentation",
          ogTitle: "Email Validation API | Real-Time & Bulk Verification",
          ogDesc: "Use KudosHub's Email Validation API for real time and bulk checks. Reduce bounces, score risk with AI, and protect sender reputation with 99% accuracy.",
          ogImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          ogUrl: "https://kudoshub.com/docs/email-validation-api",
          twitterTitle: "Email Validation API | Real-Time & Bulk Verification",
          twitterDesc: "Use KudosHub's Email Validation API for real time and bulk checks. Reduce bounces, score risk with AI, and protect sender reputation with 99% accuracy.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          dateModified: "2025-10-30T18:30:00+05:30"
        }
      },
      {
        path: "ai-email-scoring",
        loadComponent: () => import('./ai-email-scoring/ai-email-scoring.component').then(m => m.AiEmailScoringComponent),
        data: {
          title: "KudosHub AI Email Scoring | Predict Deliverability & Risk",
          description: "Boost campaign success with AI-powered email scoring. Identify risk, predict deliverability, and make smarter send decisions with KudosHub.",
          keywords: "AI email scoring, catch-all validator, catch-all checker, catch-all validation, catch-all scoring, email risk scoring, email score checker, email risk assessment",
          ogTitle: "KudosHub AI Email Scoring | Predict Deliverability & Risk",
          ogDesc: "Boost campaign success with AI-powered email scoring. Identify risk, predict deliverability, and make smarter send decisions with KudosHub.",
          ogImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          ogUrl: "https://kudoshub.com/docs/ai-email-scoring",
          twitterTitle: "KudosHub AI Email Scoring | Predict Deliverability & Risk",
          twitterDesc: "Boost campaign success with AI-powered email scoring. Identify risk, predict deliverability, and make smarter send decisions with KudosHub.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          dateModified: "2025-10-30T18:30:00+05:30"
        }
      },
      {
        path: "ai-email-scoring-api",
        loadComponent: () => import('./ai-email-scoring-api/ai-email-scoring-api').then(m => m.AiEmailScoringApi),
        data: {
          title: "AI Email Scoring API | Get Your Email Risk Score - KudosHub",
          description: "Get instant email risk scores with KudosHub’s AI Email Scoring API. Detect risky, disposable addresses and boost deliverability with real-time AI insights.",
          keywords: "AI email scoring, catch-all validator, catch-all checker, catch-all validation, catch-all scoring, email risk scoring, email score checker, email risk assessment",
          ogTitle: "AI Email Scoring API | Get Your Email Risk Score - KudosHub",
          ogDesc: "Get instant email risk scores with KudosHub’s AI Email Scoring API. Detect risky, disposable addresses and boost deliverability with real-time AI insights.",
          ogImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          ogUrl: "https://kudoshub.com/docs/ai-email-scoring-api",
          twitterTitle: "AI Email Scoring API | Get Your Email Risk Score - KudosHub",
          twitterDesc: "Get instant email risk scores with KudosHub’s AI Email Scoring API. Detect risky, disposable addresses and boost deliverability with real-time AI insights.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/docs_image.webp",
          dateModified: "2025-10-30T18:30:00+05:30"
        }
      },
    ],
  },
];